import { IMagentoStore } from '@wine-delivery/wd-shared-lib';
import { useContext } from 'react';
import { IAdminStore } from './AdminStore';
import { AdminStoreContext, StoreContext } from './ProviderStore';

export const useStore = (): IMagentoStore => useContext(StoreContext);
export const useAdminStore = (): IAdminStore => useContext(AdminStoreContext);
